module.exports = __webpack_public_path__ + "img/ico-suc.47c89011.png";